import { useLocation } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import Container from '@mui/material/Container';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomHeader from '../../General/CustomHeader';
import Page from '../../Layout/Page';
import FullScreenChartShell from '../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../styles';
import Et0IrrigationChart from './Et0IrrigationChart';
import Et0IrrigationConfigContent from './Et0IrrigationConfigContent';
import { ET0_IRRIGATION_NAME } from '../../../constants/graphs';
import { ReduxState } from '../../../types';
import { generateBreadcrumb } from '../utils';
import { ModalState, EMPTY_MODAL_STATE } from '../chartModal';

const Et0Irrigation = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, ET0_IRRIGATION_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="ETo + Riego">
        {(h) => (
          <Et0IrrigationChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            height={h}
            labelYPosition={h - 90}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='ETo + Riego'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <Et0IrrigationChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            height={450}
            marginBottom={60}
            labelYPosition={325}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        </Box>
        <Et0IrrigationConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
        />
      </Container>
    </Page>
  );
};

export default Et0Irrigation;
